import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi";

import StoreFileRequest = App.Http.Requests.File.StoreFileRequest;
import StoreFileResponse = App.Http.Responses.File.StoreFileResponse;

class FileApi extends TenantBaseApi {
    /**
     * Store file
     *
     * - Request: StoreFileRequest
     * - Response: StoreFileResponse
     */
    async store(request: StoreFileRequest | FormData): Promise<StoreFileResponse> {
        return this.post<StoreFileResponse, StoreFileRequest | FormData>("/files", request);
    }
}

export const fileApi = new FileApi();
